module.exports = __webpack_public_path__ + "static/media/Artboard5.c97f37ce.png";